// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Images/white-monkey.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .fieldUpload {
    display: none;
  }

  .custom-file-upload {
    border-radius: 50%;
    /* position: relative;
    padding: 6px; */
    cursor: pointer;
    /* background: linear-gradient(270deg, #3fa1a9, #79f1a4); */
    /* margin-bottom: 25px; */

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .custom-file-upload>.img-wrap {
    position: relative;
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 50%;
    background-color: #ccc;
    flex-direction: column;
    flex: 1 1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
  }

  /* .custom-file-upload > .img-upload:before{
    content: "\\f093";
    font-size: 90px;
    position: absolute;
    padding-top: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #63d3a6;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    opacity: 0;
    transition: .5s ease;
    background-color: #fff;
  }

  .custom-file-upload > .img-upload:hover:before{
   opacity: 1;
  } */

  .photo-upload {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .custom-file-upload>label {
    text-transform: uppercase;
    font-weight: 700;
    color: #676767;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }`, "",{"version":3,"sources":["webpack://./src/Assets/Css/Components/FieldProfileUpload.css"],"names":[],"mappings":"EAAE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB;mBACe;IACf,eAAe;IACf,2DAA2D;IAC3D,yBAAyB;;IAEzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,SAAO;IACP,yDAAsD;IACtD,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;;;;;;;;;;;;;;;;;;;KAoBG;;EAEH;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;EAChC","sourcesContent":["  .fieldUpload {\n    display: none;\n  }\n\n  .custom-file-upload {\n    border-radius: 50%;\n    /* position: relative;\n    padding: 6px; */\n    cursor: pointer;\n    /* background: linear-gradient(270deg, #3fa1a9, #79f1a4); */\n    /* margin-bottom: 25px; */\n\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n\n  .custom-file-upload>.img-wrap {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    overflow: hidden;\n    border-radius: 50%;\n    background-color: #ccc;\n    flex-direction: column;\n    flex: 1;\n    background-image: url(\"../../Images/white-monkey.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n\n  /* .custom-file-upload > .img-upload:before{\n    content: \"\\f093\";\n    font-size: 90px;\n    position: absolute;\n    padding-top: 80px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: #63d3a6;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    opacity: 0;\n    transition: .5s ease;\n    background-color: #fff;\n  }\n\n  .custom-file-upload > .img-upload:hover:before{\n   opacity: 1;\n  } */\n\n  .photo-upload {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .custom-file-upload>label {\n    text-transform: uppercase;\n    font-weight: 700;\n    color: #676767;\n\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
